import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="divider" />
      <div className="footer-inner">
        <span className="footer-copy">© {new Date().getFullYear()} Nicolo Tabar</span>
      </div>
    </footer>
  );
};

export default Footer;
